import { t } from 'i18next';
import './StatusFilms.css';

interface StatusFilmsProps {
  redText?: string;
  yellowText?: string;
  greenText?: string;
}

export default function StatusFilms({
  redText = 'Insumo no cargado',
  yellowText = 'Insumo en proceso de carga',
  greenText = 'Insumo cargado',
}: StatusFilmsProps) {
  return (
    <div className="status-films">
      <div className="status-films__item">
        <div className="status-films__circle status-films__circle--red" />
        <p className="status-films__text">{t(redText)}</p>
      </div>

      <div className="status-films__item">
        <div className="status-films__circle status-films__circle--yellow" />
        <p className="status-films__text">{t(yellowText)}</p>
      </div>

      <div className="status-films__item">
        <div className="status-films__circle status-films__circle--green" />
        <p className="status-films__text">{t(greenText)}</p>
      </div>
    </div>
  );
}
